// extracted by mini-css-extract-plugin
module.exports = {"iconTooltip":"IconTooltip_iconTooltip__2Yscn","tooltip-effect":"IconTooltip_tooltip-effect__2ehtO"};